import { render, staticRenderFns } from "./papers.vue?vue&type=template&id=fa34d87a&"
import script from "./papers.vue?vue&type=script&lang=js&"
export * from "./papers.vue?vue&type=script&lang=js&"
import style0 from "./papers.vue?vue&type=style&index=0&id=fa34d87a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports